import React from 'react';
import {
  Content,
  Section,
  ButtonContainer,
  ButtonGrid,
  ActionButton,
} from '../EntityPermissionsWidgetPopover/EntityPermissionsWidgetPopoverUI';
import { SvgIcon } from '../../Icon';
import styled from 'styled-components';
import { theme } from '../../../styles/theme';
import useDashboardSelector from '../../../redux/selectorHooks/useDashboardSelector';
import { useAnalytics } from '../../../utils/analytics/useAnalytics';
import { buttonClicked } from '../../../utils/analytics/events/button/events';
import { useExternalEmbedFeature } from '../../../utils/hooks';
interface IProps {
  setShowEmbedContent: (show: boolean) => void;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 12px;
  border-top: 1px solid ${theme.colors.secondary300};
  padding-top: 12px;
`;

const DashboardShareContent = ({ setShowEmbedContent }: IProps) => {
  const dashboard = useDashboardSelector('dashboard');
  const isEmbedFeatureEnabled = useExternalEmbedFeature();

  const { track } = useAnalytics();

  const onEmbedCodeClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    setShowEmbedContent(true);
  };

  const onExportClick = () => {
    track(buttonClicked({ context: 'dashboard', action: 'export_pdf' }));

    if (dashboard?.exportUrl) {
      window.location.href = dashboard.exportUrl;
    }
  };

  return (
    <Container>
      <Content>
        <Section>
          <ButtonGrid>
            {isEmbedFeatureEnabled && (
              <ButtonContainer onClick={onEmbedCodeClick}>
                <ActionButton isOutlined={true}>
                  <SvgIcon name="code-regular" width={24} height={24} />
                </ActionButton>
                Embed code
              </ButtonContainer>
            )}
            <ButtonContainer onClick={onExportClick}>
              <ActionButton isOutlined={true}>
                <SvgIcon name="export-to-pdf" width={24} height={24} />
              </ActionButton>
              Export to PDF
            </ButtonContainer>
          </ButtonGrid>
        </Section>
      </Content>
    </Container>
  );
};

export default DashboardShareContent;
